import React, { useState, useEffect, useRef } from "react";
import { FormControl, InputGroup, Button, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import ApiManager from "../utils/ApiManager"; // Adjust the path as per your directory structure
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import HistoryIcon from '@mui/icons-material/History';
import "react-datepicker/dist/react-datepicker.css";
import DataManager from "../utils/DataManager";

import ModalMessage from "./ModalMessage";

const WireTransferSearch = ({ onFiltersChange, setLoading }) => {
  const today = new Date();
  const fiveDaysAgo = new Date(today);
  fiveDaysAgo.setDate(today.getDate() - 5);
  
  const [searchPattern, setSearchPattern] = useState("");
  const [searchDateFrom, setSearchDateFrom] = useState(fiveDaysAgo);
  const [searchDateTo, setSearchDateTo] = useState("");
  const [searchStatus, setSearchStatus] = useState("");

  const [modalMessage, setModalMessage] = useState({ showModal: false });

  const inputRef = useRef(null);

  useEffect(() => {
    filterChange();
    
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const filterChange = () => {
    if (onFiltersChange) {
      onFiltersChange({
        search: searchPattern,
        from: DataManager.Date.fromISO(searchDateFrom || ""),
        to: DataManager.Date.fromISO(searchDateTo || ""),
        status: searchStatus
      });
    }
  }

  const fetchWireTransferImport = () => {
    if (setLoading != null) setLoading(true);
    ApiManager.Top.wiretransfersImport(
      {},
      (data) => {
        if (setLoading != null) setLoading(false);

        if ((data != null) && ((data.message || "") != "")) {
          handleOpenModal("Error", data.message);
        }
        else {
          filterChange();
        }
      },
      (error) => {
        if (setLoading != null) setLoading(false);
        console.error("Error fetching wiretransfer import:", error);
        handleOpenModal("Error", "Si è verificato un problema sull'importazione dei bonifici.");
      },
      () => {}
    );
  };

  const handleSearchPatternChange = (e) => {
    setSearchPattern(e.target.value);
  };

  const handleSearchDateFromChange = (value) => {
    setSearchDateFrom(value);
  };

  const handleSearchDateToChange = (value) => {
    setSearchDateTo(value);
  };

  const handleSearchStatusChange = (e) => {
    setSearchStatus(e.target.value);
  };

  const handleSearchClick = () => {
    filterChange();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearchClick();
    }
  };

  const handleImportClick = (e) => {
    fetchWireTransferImport();
  }

  const handleClearClick = () => {
    setSearchPattern("");
    setSearchDateFrom("");
    setSearchDateTo("");
    setSearchStatus("");
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const onCloseModal = () => {
    setModalMessage({ showModal: false });
  }

  // open modal
  const handleOpenModal = (title, message) => {
    setModalMessage({ showModal: true, title: title, message: message, onCloseModal: onCloseModal });
  }

  return (
    <>
      <Row className="mb-3">
        <Col md={12} style={{textAlign: "right"}}>
          <Button
            title="Importa"
            variant="primary"
            id="button-import"
            onClick={handleImportClick}
          >
            Importa
          </Button>          
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={1}>
          {((searchPattern || searchDateFrom || searchDateTo || searchStatus) === "") || (
            <Button
              title="Cancella"
              variant="outline-secondary"
              id="button-addon3"
              onClick={handleClearClick}
            >
              <ClearIcon />
            </Button>
          )}
        </Col>  
        <Col md={4}>          
          <FormControl
            id="searchPattern"
            ref={inputRef}
            type="text"
            placeholder="cerca nella descrizione..."
            aria-label="Search"
            aria-describedby="button-addon2"
            value={searchPattern}
            onChange={handleSearchPatternChange}
            onKeyDown={handleKeyDown}
          />
        </Col>  
        <Col md={2}>
          <DatePicker
            id="searchDateFrom"
            placeholderText={"Dalla data"}
            selected={searchDateFrom}
            onChange={(d) => handleSearchDateFromChange(d)}
            dateFormat="dd/MM/yyyy"
            locale="it"
            className="form-control"     // rende lo stile uguale ai campi bootstrap
            onKeyDown={handleKeyDown}
          />
        </Col>      
        <Col md={2}>
          <DatePicker
            id="searchDateTo"
            placeholderText={"Alla data"}
            selected={searchDateTo}
            onChange={(d) => handleSearchDateToChange(d)}
            dateFormat="dd/MM/yyyy"
            locale="it"
            className="form-control"     // rende lo stile uguale ai campi bootstrap
            onKeyDown={handleKeyDown}
          />
        </Col>      
        <Col md={2}>
          <FormControl
            as="select"
            value={searchStatus}
            onChange={handleSearchStatusChange}
          >
            <option value="">{"* Tutti *"}</option>
            <option value="NONE">{"Non spuntati"}</option>
            <option value="CHECKED">{"Spuntati"}</option>
            <option value="ERROR">{"In errore"}</option>
          </FormControl>      
        </Col>      
        <Col md={1}>
          <Button
            title="Cerca"
            variant="primary"
            id="button-addon2"
            onClick={handleSearchClick}
          >
            <SearchIcon />
          </Button>
        </Col>
      </Row>
      <ModalMessage
        modalData={modalMessage}
      />
    </>
  );
};

export default WireTransferSearch;
